"use client";

import { useEffect } from "react";
import Link from "next/link";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50 px-4">
      <div className="max-w-sm w-full text-center">
        <div className="w-16 h-16 rounded-2xl bg-red-50 flex items-center justify-center mx-auto mb-6">
          <span className="text-3xl">⚠️</span>
        </div>
        <h1 className="text-xl font-bold text-stone-900 mb-3">
          Algo salió mal
        </h1>
        <p className="text-stone-500 text-sm leading-relaxed mb-8">
          Ocurrió un error inesperado. Intenta actualizar la página o vuelve más tarde.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={reset}
            className="inline-flex items-center justify-center gap-2 bg-violet-600 hover:bg-violet-700 text-white text-sm font-semibold px-5 py-2.5 rounded-xl transition-colors"
          >
            Intentar de nuevo
          </button>
          <Link
            href="/dashboard"
            className="inline-flex items-center justify-center gap-2 bg-white border border-stone-200 hover:bg-stone-50 text-stone-700 text-sm font-semibold px-5 py-2.5 rounded-xl transition-colors"
          >
            Al panel
          </Link>
        </div>
        {error.digest && (
          <p className="text-xs text-stone-400 mt-6">Código de error: {error.digest}</p>
        )}
      </div>
    </div>
  );
}
